// extracted by mini-css-extract-plugin
export default {"header-logo__custom-btn":"header_header-logo__custom-btn__rZLna"};